import React from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { useMergeContactModalStore } from "../store/useMergeContactModalStore";

export const MergeContactConfirmationModal = () => {
  const open = useMergeContactModalStore(
    (state) => state.openConfirmationModal
  );
  const setOpenModal = useMergeContactModalStore(
    (state) => state.setOpenConfirmationModal
  );

  const handleSubmit = () => {};
  return (
    <ExlyModal
      title="Verify details of the new merged profile"
      open={open}
      onClose={() => setOpenModal(false)}
      primaryBtnText="Yes, I’m sure"
      onPrimaryBtnClick={handleSubmit}
      showSecondaryBtn
      onSecondaryBtnClick={() => setOpenModal(false)}
      modal_props={{
        primaryBtnClassName: "!tw-w-full",
        secondaryBtnClassName:
          "!tw-font-medium !tw-border-[1.5px] !tw-border-solid !tw-rounded-[5px] !tw-border-[#272522] !tw-w-full hover:!tw-bg-transparent",
      }}
      primaryBtnProps={{
        buttonWrapperClassName: "!tw-w-full",
      }}
      secondaryBtnProps={{
        buttonWrapperClassName: "!tw-w-full",
      }}
      className="!tw-p-0"
    >
      <div className="tw-p-[16px]">
        <span className="tw-font-bold tw-text-[#BA030F]">
          This action can’t be reverted
        </span>
        , i.e Once merged, the profiles can’t be separated. Ensure that you are
        merging the correct profiles.
      </div>
    </ExlyModal>
  );
};
